import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogPaper
} from '@/modules/components/ui/dialog'
import { ComponentPropsWithoutRef, ReactNode } from 'react'
import { LeadForm } from './lead-form'

export const LeadFormDialog = ({
  children,
  ...rest
}: { children?: ReactNode } & ComponentPropsWithoutRef<typeof Dialog>) => {
  return (
    <Dialog {...rest}>
      {/* {!!children && <DialogTrigger asChild>{children}</DialogTrigger>} */}
      <DialogContent className=''>
        <DialogClose />
        <DialogPaper className='box-border w-full md:w-[704px]'>
          <p className='pr-[40px] text-[30px] md:text-[50px] font-medium leading-[1] tracking-[-0.04em] mb-[24px]'>
            Заполните форму и&nbsp;наш менеджер свяжется с&nbsp;вами
          </p>
          <LeadForm
            className='w-full sizin'
            buttonText='Записаться на курс'
            inputClassName='bg-secondary box-border'
          />
        </DialogPaper>
      </DialogContent>
    </Dialog>
  )
}
